import { MergedBase } from "../mfrm-choose-your-foundation";
export const hasDiscount = (base: MergedBase) => {
    return typeof base.DiscountAmount !== 'undefined' && base.DiscountAmount > 0;
};